module.exports = __webpack_public_path__ + "static/media/vitaldetails4.2caff306.png";